'use client'

import useMetaLocatorScript from '../../cms/metaLocator/useMetaLocatorScript'

export const DealerLocatorEffects = ({ itemId }: { itemId?: string }) => {
  useMetaLocatorScript({ itemId })
  return null
}
